import {
  GetCategoryRequest,
  GetCategoryResponse,
} from '@bukalapak/protocgen/src/products/mitrabangunan/product/v2/private/category_pb'
import { NuxtAxiosInstance } from '@nuxtjs/axios'
import { CategoryApiPath } from '~/types/api/category'

export const PublicCategoryApi = {
  getCategory($axios: NuxtAxiosInstance, params: Partial<GetCategoryRequest.AsObject>) {
    return $axios.$get<GetCategoryResponse.AsObject>(CategoryApiPath.getCategory, {
      params,
    })
  },
}
